const env = process.env.ENVIRONMENT || process.env.NODE_ENV;
// Load different configs for production, qa or development
let configFile = 'prod';

console.log(`config file is: ${configFile}`, env)
export const params = require(`./config.${configFile}.js`);


export const delayLoadingComponentTime = 500;
